import appService from "./services";
import { Promise } from "es6-promise";

export const getFeatures = () => {
  return new Promise(function(resolve, reject) {
    resolve(appService.getFeatures());
  });
};
